const Types = {
    GET_PLACES: 'GET_PLACES',
    FAILED_GET_PLACES: 'FAILED_GET_PLACES',
    COMPLETE_GET_PLACES: 'COMPLETE_GET_PLACES',

    ADD_PLACE: 'ADD_PLACE',
    FAILED_ADD_PLACE: 'FAILED_ADD_PLACE',
    COMPLETE_ADD_PLACE: 'COMPLETE_ADD_PLACE',

    DELETE_SELECTED_PLACE: 'DELETE_SELECTED_PLACE',
    FAILED_DELETE_PLACE: 'FAILED_DELETE_PLACE',
    COMPLETE_DELETE_PLACE: 'COMPLETE_DELETE_PLACE',

    GET_PROFILE: 'GET_PROFILE',
    FAILED_GET_PROFILE: 'FAILED_GET_PROFILE',
    COMPLETE_GET_PROFILE: 'COMPLETE_GET_PROFILE',

    CREATE_PROFILE: 'CREATE_PROFILE',
    FAILED_CREATE_PROFILE: 'FAILED_CREATE_PROFILE',
    COMPLETE_CREATE_PROFILE: 'COMPLETE_CREATE_PROFILE',

    SET_LOADING: 'SET_LOADING',
  
    ASC_PLACES: 'ASC_PLACES',
    DESC_PLACES: 'DESC_PLACES',

    // SET_NEXTNEXT_TOKEN: 'SET_NEXTNEXT_TOKEN',
}

export default Types;